import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Modal, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { competitorAPI } from '../../../../../../services/api';
import { CompetitorASIN } from '../../../../../../types';
import { getCompetitorColumns } from './components/CompetitorTableColumns';
import { AddCompetitorModal } from './components/AddCompetitorModal';

export const CompetitorTracking: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const skuId = Number(id);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<CompetitorASIN[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [scrapping, setScrapping] = useState<Record<number, boolean>>({});

    useEffect(() => {
        if (skuId) {
            fetchData();
        }
    }, [skuId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await competitorAPI.list({ sku: skuId });
            setData(response.data);
        } catch (error) {
            console.error('Fetch competitors failed:', error);
            message.error('获取竞品列表失败');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (recordId: number) => {
        Modal.confirm({
            title: '确认删除',
            content: '确定要删除这个竞品吗？',
            onOk: async () => {
                try {
                    await competitorAPI.delete(recordId);
                    message.success('删除成功');
                    fetchData();
                } catch (error) {
                    message.error('删除失败');
                }
            }
        });
    };

    const handleSync = async (record: CompetitorASIN) => {
        setScrapping(prev => ({ ...prev, [record.id]: true }));
        try {
            await competitorAPI.syncDetails(record.id);
            message.success(`ASIN ${record.asin} 详情同步成功`);
            fetchData();
        } catch (error) {
            message.error('同步失败');
        } finally {
            setScrapping(prev => ({ ...prev, [record.id]: false }));
        }
    };

    const columns = getCompetitorColumns(handleSync, handleDelete, scrapping);

    return (
        <Card title="竞品信息追踪" extra={
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalVisible(true)}>
                添加竞品
            </Button>
        }>
            <Table
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={data}
                pagination={false}
            />

            <AddCompetitorModal
                skuId={skuId}
                visible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                onSuccess={fetchData}
            />
        </Card>
    );
};
